import type { UseRadioProps } from '@chakra-ui/react';
import { Box, useRadio } from '@chakra-ui/react';
import { type ReactNode, useId } from 'react';

interface ProductFormRadioProps extends UseRadioProps {
  children: ReactNode;
  isDisabled?: boolean;
  isVertical?: boolean;
}

export function ProductFormRadio({
  isVertical,
  isDisabled,
  children,
  ...props
}: ProductFormRadioProps) {
  const labelId = useId();
  const { getInputProps, getRadioProps } = useRadio(props);
  const input = getInputProps();
  const radio = getRadioProps();

  return (
    <Box as="label" minH={isVertical ? 'initial' : 71}>
      <input {...input} disabled={isDisabled} aria-labelledby={labelId} />
      <Box
        {...radio}
        id={labelId}
        role="group"
        display="flex"
        alignItems="center"
        h="full"
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        borderWidth="1px"
        borderRadius="base"
        borderColor="blackAlpha.250"
        py="2xs"
        _checked={{
          borderColor: 'gray.600',
        }}
        _focusVisible={{
          boxShadow: 'outline',
        }}
        _disabled={{
          bgColor: 'gray.100',
          color: 'blackAlpha.700',
          cursor: 'not-allowed',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
